import script from "./CsDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./CsDashboard.vue?vue&type=script&setup=true&lang=js"

import "./CsDashboard.vue?vue&type=style&index=0&id=2bc8b770&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bc8b770"]])

export default __exports__